/**
 * Shared Styles for Devops Form View Component
 */

import { B300, B400, G300, N900, R400, R500 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';

export const fontCharlieText =
  '"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",' +
  'Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';

export const fontCharlieDisplay =
  '"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",' +
  'Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';

type ValidationState = {
  readonly validationState?: string;
  readonly isDisabled?: boolean;
};

export const FieldWrapper = styled.div<ValidationState>`
  position: relative;
  margin: 0;
  padding: 0;

  input {
    height: 20px;
    box-sizing: content-box;
  }

  > div {
    transition all 0.1s linear 0s;
    opacity: ${(props) => {
      if (props.isDisabled) {
        return 0.4;
      }
      return 1;
    }};
    ${(props) => {
      if (props.validationState === 'success') {
        return ` border-color:${G300} !important`; // green
      }
      if (props.validationState === 'error') {
        return ` border-color:${R400} !important`; // red
      }
      return '';
    }};
  }
`;

export const ErrorMessage = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
  margin: 16px 0;
  font-size: 12px;
  line-height: 12px;

  position: absolute;
  display: grid;
  justify-items: center;
  align-items: start;
  width: 100%;
  margin: 0;
  z-index: 9;
  color: ${N900};
  background: transparent !important;

  &.location-top {
    bottom: 100%;
  }

  &.location-bottom {
    top: 100%;
  }

  & > div {
    display: flex;
  }

  span {
    padding: 7px;
    background: white;
    box-shadow: 0px 0px 1px rgba(9, 30, 66, 0.31),
      0px 3px 5px rgba(9, 30, 66, 0.2);
    border-radius: 3px;
    margin: 2px auto 0;
    max-width: 90%;
    line-height: 1.2em;
  }

  a {
    text-decoration: none;
    color: ${B400};

    &:hover {
      text-decoration: underline;
      color: ${B300};
    }
  }
`;
export const SubmitErrorMessage = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
  margin: 16px 0;
  font-size: 13px;
  line-height: 12px;
  font-family: ${fontCharlieText};
  position: relative;
  display: grid;
  justify-items: center;
  align-items: start;
  width: 100%;
  margin: 0;
  color: ${R500};
  background: transparent !important;

  &.location-top {
    bottom: 100%;
  }

  span {
    background: none;
    margin-top: 15px;
    max-width: 90%;
    line-height: 1.2em;
  }

  a {
    text-decoration: none;
    color: ${B400};

    &:hover {
      text-decoration: underline;
      color: ${B300};
    }
  }
`;
